module.exports = __webpack_public_path__ + "static/RARI-8631b3644551a2ea75750cd8ad2f0b66.svg";